import { PUBLICATION_STATE } from '~/scopes/listings/Listings.constants'

import type { InitialFilterValues } from './Filters.types'

export const INITIAL_FILTERS_VALUES: InitialFilterValues = {
  aestheticGrade: '',
  categoryId: '',
  hasBackbox: '',
  hasNewBattery: '',
  hasStock: '',
  markets: '',
  orderBy: '-quantity',
  pageSize: '10',
  productId: '',
  publicationStates: '',
  sku: '',
  title: '',
  backboxPriceMinRange: '',
  backboxPriceMaxRange: '',
  backboxPriceRangeType: '',
  backboxPriceCurrencyCode: '',
  pricingStrategy: '',
}

export const OPTION_VALUE_ALL = ''

export const FILTER_FIELDS = {
  TITLE: 'title',
  SKU: 'sku',
  UUID: 'uuid',
  GRADE: 'grade',
  BACKBOX: 'backbox',
  STOCK: 'stock',
  MARKET: 'market',
  CATEGORY_ID: 'categoryId',
  HAS_NEW_BATTERY: 'hasNewBattery',
  BACKBOX_PRICE_RANGE: 'backboxPriceRange',
  PRICING_STRATEGY: 'pricingStrategy',
}

export const FILTER_FIELDS_LIST = Object.values(FILTER_FIELDS)

export const FILTERS_BY_PUBLICATION_STATE = {
  [PUBLICATION_STATE.ONLINE]: FILTER_FIELDS_LIST,
  [PUBLICATION_STATE.IN_VALIDATION]: [
    FILTER_FIELDS.TITLE,
    FILTER_FIELDS.SKU,
    FILTER_FIELDS.GRADE,
    FILTER_FIELDS.CATEGORY_ID,
    FILTER_FIELDS.HAS_NEW_BATTERY,
  ],
  [PUBLICATION_STATE.DISABLED]: [
    FILTER_FIELDS.TITLE,
    FILTER_FIELDS.SKU,
    FILTER_FIELDS.GRADE,
    FILTER_FIELDS.CATEGORY_ID,
    FILTER_FIELDS.HAS_NEW_BATTERY,
  ],
}
